// extracted by mini-css-extract-plugin
export default {"header":"Header_header__N41AG","left":"Header_left__+pi5T","navigationMobile":"Header_navigationMobile__h3IDS","logo":"Header_logo__IKcRf","navigation":"Header_navigation__ZdHOS"};